import { RegistriaOrderInformation } from './registria-order-information.interface';

export interface RegistriaUpdateUserOrderRequest {
  orderInfo: RegistriaOrderInformation;
}
